var render, staticRenderFns
import script from "./consumption_integral.vue?vue&type=script&lang=js"
export * from "./consumption_integral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cf7d52b')) {
      api.createRecord('6cf7d52b', component.options)
    } else {
      api.reload('6cf7d52b', component.options)
    }
    
  }
}
component.options.__file = "found/views/mall/views/integral_mall_management/consumption_integral/consumption_integral.vue"
export default component.exports